import type { RootState } from 'app/reducers/index.ts';

function create<T>(selector: (state: RootState['translator']) => T): (state: RootState) => T {
  return (state: RootState) => selector(state.translator);
}

export const translatorSelector = create((s) => s);
export const currentStateSelector = create(s => s.currentState);
export const conversationIdSelector = create(s => s.conversationId);
